import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-7b0a3a02"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "chart-container" };
const _hoisted_2 = { class: "filters mb-4" };
const _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<option value=\"7d\" data-v-7b0a3a02>Últimos 7 Días</option><option value=\"30d\" data-v-7b0a3a02>Últimos 30 Días</option><option value=\"3m\" data-v-7b0a3a02>Últimos 3 Meses</option><option value=\"6m\" data-v-7b0a3a02>Últimos 6 Meses</option><option value=\"12m\" data-v-7b0a3a02>Últimos 12 Meses</option><option value=\"custom\" data-v-7b0a3a02>Rango Personalizado</option>", 6);
const _hoisted_9 = [
    _hoisted_3
];
const _hoisted_10 = {
    key: 0,
    class: "custom-date-range"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Bar = _resolveComponent("Bar");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedFilter) = $event)),
                onChange: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.applyFilter && _ctx.applyFilter(...args))),
                class: "filter-select"
            }, _hoisted_9, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, _ctx.selectedFilter]
            ]),
            _createCommentVNode(" Rango de Fechas Personalizado "),
            (_ctx.selectedFilter === 'custom')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startDate) = $event)),
                        onChange: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.applyDateRange && _ctx.applyDateRange(...args)))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, _ctx.startDate]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.endDate) = $event)),
                        onChange: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.applyDateRange && _ctx.applyDateRange(...args)))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, _ctx.endDate]
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Asegúrate de que chartData y chartOptions estén disponibles antes de renderizar el gráfico "),
        (_ctx.chartData.labels.length > 0)
            ? (_openBlock(), _createBlock(_component_Bar, {
                key: 0,
                data: _ctx.chartData,
                options: _ctx.chartOptions
            }, null, 8 /* PROPS */, ["data", "options"]))
            : _createCommentVNode("v-if", true)
    ]));
}
